<template>
  <div class="timeline-item">
    <div class="timeline-marker" :class="getMarkerClass"></div>
    <div class="timeline-content">
      <p class="timeline-date">{{ date }}</p>
      <div class="timeline-title">
        <i :class="iconClass" class="mr-2"></i>
        <strong>{{ title }}</strong>
      </div>
      <p class="timeline-description">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimelineItem",

  props: {
    date: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "fa-circle",
    },
    type: {
      type: String,
      default: "info",
      validator: (value) =>
        ["info", "warning", "success", "danger", "dark"].includes(value),
    },
  },

  computed: {
    /**
     * Get marker CSS class based on type
     */
    getMarkerClass() {
      return `is-${this.type}`;
    },

    /**
     * Get full icon class
     */
    iconClass() {
      return `fa ${this.icon}`;
    },
  },
};
</script>

<style scoped>
.timeline-item {
  position: relative;
  margin-bottom: 1.5rem;
}

.timeline-item:not(:last-child)::before {
  content: "";
  position: absolute;
  left: -1.5rem;
  top: 1rem;
  width: 2px;
  height: calc(100% + 0.5rem);
  background-color: hsl(0, 0%, 42%);
}

.timeline-marker {
  position: absolute;
  left: -1.75rem;
  top: 0.25rem;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background-color: hsl(0, 0%, 42%);
  border: 2px solid hsl(0, 0%, 21%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
}

.timeline-marker.is-info {
  background-color: hsl(229, 53%, 71%);
}

.timeline-marker.is-warning {
  background-color: hsl(44, 100%, 77%);
}

.timeline-marker.is-success {
  background-color: hsl(153, 53%, 53%);
}

.timeline-marker.is-danger {
  background-color: hsl(348, 86%, 61%);
}

.timeline-marker.is-dark {
  background-color: hsl(0, 0%, 21%);
  border-color: hsl(0, 0%, 42%);
}

.timeline-content {
  margin-left: 0.5rem;
}

.timeline-date {
  font-size: 0.875rem;
  color: hsl(0, 0%, 71%);
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.timeline-title {
  font-size: 1rem;
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
  color: hsl(0, 0%, 96%);
}

.timeline-title strong {
  color: hsl(0, 0%, 96%);
}

.timeline-description {
  font-size: 0.9rem;
  color: hsl(0, 0%, 71%);
  margin-bottom: 0;
  line-height: 1.4;
}

.mr-2 {
  margin-right: 0.5rem;
}
</style>
